export const Declarations = "DECLARATIONS";
